import {
	Capabilities,
	Capability,
} from '../types/capabilities/capabilities.system.types';
import { SystemType, SystemTypeRaw } from '../types/system.types';

/**
 * Implementation of the SystemType interface.
 */
export class SystemTypeImpl implements SystemType {
	id: string;
	displayName: string;
	defaultColour: string;
	assetTypes: string[];
	private readonly capabilities: Capability[];

	/**
	 * Constructs a new SystemTypeImpl instance.
	 * @internal
	 * @param params - The raw system type parameters.
	 */
	constructor(params: SystemTypeRaw) {
		this.id = params.SystemType;
		this.displayName = params.DisplayName;
		this.defaultColour = params.DefaultColour;
		this.assetTypes = params.AssetTypes;

		this.capabilities = [];
		for (const capability of Capabilities) {
			if (params[capability]) {
				this.capabilities.push(capability);
			}
		}
	}

	/**
	 * Checks if the system type has a specific capability.
	 * @param capability - The capability to check.
	 * @returns True if the capability exists, false otherwise.
	 */
	hasCapability(capability: Capability): boolean {
		return this.capabilities.includes(capability);
	}
}
